import api from 'configs/api'
import React from 'react'
import { IDashMetrics } from './Interfaces'

export const findDashMetrics = async (
  setMetrics: React.Dispatch<React.SetStateAction<IDashMetrics>>,
  month: string,
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>
): Promise<void> => {
  try {
    setLoading?.(true)
    const dataInStorage: any = window.localStorage.getItem('@StarBem:user')
    const dataParse = JSON.parse(dataInStorage)

    const find = await api.get(
      `/schedulings/ms/v1/reports/appointments/doctor/month?doctor_id=${dataParse.id}&month=${month}`
    )

    const metrics = find.data
    setMetrics({
      ...metrics,
      started: metrics.started ?? '0',
      started_tp: metrics.started_tp ?? '0',
      total_tp: metrics.total_tp ?? '0',
      pending_tp: metrics.pending_tp ?? '0',
      finished_tp: metrics.finished_tp ?? '0',
      finished_60_tp: metrics.finished_60_tp ?? '0',
      noshow_tp: metrics.noshow_tp ?? '0',
      noshow_60_tp: metrics.noshow_60_tp ?? '0',
      canceled_by_30_min_tp: metrics.canceled_by_30_min_tp ?? '0',
      canceled_60_by_30_min_tp: metrics.canceled_60_by_30_min_tp ?? '0',
      canceled_tp: metrics.canceled_tp ?? '0',
      slots_occupied: metrics.slots_occupied ?? 0,
      slots_total: metrics.slots_total ?? 0,
    })
  } catch (err) {
    console.error(err)
  } finally {
    setLoading?.(false)
  }
}
